import { render, staticRenderFns } from "./DSelect.vue?vue&type=template&id=6495a8d5&scoped=true&"
import script from "./DSelect.vue?vue&type=script&lang=js&"
export * from "./DSelect.vue?vue&type=script&lang=js&"
import style0 from "./DSelect.vue?vue&type=style&index=0&id=6495a8d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6495a8d5",
  null
  
)

export default component.exports